/**
 * El campo `custom` del botón de PayPal: lo único nuestro que vuelve en el IPN.
 *
 * PayPal lo corta en 256 caracteres, y lo que pasa de ahí no llega. Por eso los
 * obligatorios van siempre y primero —sin ellos el IPN no sabe de quién es el
 * pago— y los opcionales entran de a uno, en orden de prioridad, mientras
 * quepan. Uno que no entra no corta a los que siguen: uno más corto puede caber.
 *
 * Los opcionales vacíos no se mandan. Antes iban igual (`@tapfiliate_click_id:`
 * sin valor en casi todos los pagos), y eran 21 caracteres que dejaban afuera
 * al `_ga` y a la sesión que el backend necesita para atribuir la compra a su
 * canal (VEX-7058).
 */
export const PAYPAL_CUSTOM_MAX = 256;

const isEmpty = (value) => value === undefined || value === null || value === '';

export const buildPaypalCustom = (required, optional = {}, max = PAYPAL_CUSTOM_MAX) => {
  let custom = '';
  for (const [key, value] of Object.entries(required)) {
    custom += key + ':' + value;
  }
  for (const [key, value] of Object.entries(optional)) {
    if (isEmpty(value)) continue;
    const next = custom + key + ':' + value;
    if (next.length <= max) custom = next;
  }
  return custom;
};

export default buildPaypalCustom;
